import { FC } from 'react';
import * as React from 'react';

import { Drawer, MenuItem } from '@crehana/ui';

import {
  FAQ_LINKS,
  FAQS_BY_STUDENT_TYPE,
} from '@/views/UserDashboard/constants';
import { useCrehanaTranslation } from '@/views/UserDashboard/hooks';

import type { StudentType } from '../../types';

interface MobileFAQsProps {
  open: boolean;
  onDismiss: () => void;
  toggleTour: () => void;
  studentType: StudentType;
}

const MobileFAQs: FC<React.PropsWithChildren<MobileFAQsProps>> = ({
  open,
  onDismiss,
  toggleTour,
  studentType,
}) => {
  const t = useCrehanaTranslation();

  return (
    <Drawer
      className="flex flex-col"
      open={open}
      onDismiss={onDismiss}
      position="bottom"
    >
      <MenuItem
        className="justify-center"
        label={t('UD_FAQ_ONBOARDING')}
        onClick={() => {
          onDismiss();
          toggleTour();
        }}
      />
      <MenuItem
        className="justify-center"
        label={t('UD_FAQ_COURSE')}
        onClick={() => {
          window.open(FAQ_LINKS.FAQ_COURSE);
          onDismiss();
        }}
      />
      {FAQS_BY_STUDENT_TYPE[studentType].map(({ key, text, href }) => (
        <MenuItem
          key={key}
          className="justify-center"
          label={text}
          onClick={() => {
            window.open(href);
            onDismiss();
          }}
        />
      ))}
    </Drawer>
  );
};

export default React.memo(MobileFAQs);
